import {  ASSIGN_AGENT_URL, STORE_LISTING_BULK_UPLOAD_URL } from "../../config/Url";
import axios from "../../interceptors/axiosInterceptor";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";


export const agentChatwootAssignmentApi = (payload: FormData) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(ASSIGN_AGENT_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(data);
        } 
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });


  export const agentStoreAssignmentApi = (payload: FormData) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(STORE_LISTING_BULK_UPLOAD_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(data);
        } 
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
